import { Link } from 'react-router-dom';
import { Chip, Spinner } from '@heroui/react';
import { ArrowLeft } from 'lucide-react';
import { useVisitPage } from './useVisitPage';
import { VisitAiCard } from './components/VisitAiCard';
import { VisitInfoCard } from './components/VisitInfoCard';
import { VisitLocationCard } from './components/VisitLocationCard';
import { VisitTasksList } from './components/VisitTasksList';
import { VISIT_STATUS_COLORS, VISIT_STATUS_LABELS } from '@/lib/visitStatus';
import { PageContainer } from '@/components/templates/PageContainer';

export function VisitPage() {
  const { visit, isLoading, error, notFound } = useVisitPage();

  return (
    <PageContainer>
      <div className="mb-4 flex items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-3">
          <Link
            to="/visits"
            className="flex shrink-0 items-center gap-1 text-sm text-muted hover:text-foreground"
          >
            <ArrowLeft className="size-4" />
            Визиты
          </Link>
          <h2 className="truncate text-2xl font-bold text-foreground">
            {visit ? visit.template.title : 'Визит'}
          </h2>
          {visit && (
            <Chip
              className="shrink-0"
              color={VISIT_STATUS_COLORS[visit.status]}
              size="sm"
              variant="soft"
            >
              {VISIT_STATUS_LABELS[visit.status]}
            </Chip>
          )}
        </div>
      </div>

      {error && (
        <p className="mb-3 rounded-[var(--radius)] bg-danger px-3 py-2 text-sm text-danger-foreground">
          {error}
        </p>
      )}

      {isLoading ? (
        <div className="flex items-center justify-center gap-2 py-20 text-sm text-muted">
          <Spinner size="sm" />
          Загрузка…
        </div>
      ) : notFound ? (
        <p className="py-20 text-center text-sm text-muted">Визит не найден</p>
      ) : visit ? (
        <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-[1fr_360px]">
          <div className="flex min-w-0 flex-col gap-4">
            <VisitAiCard visit={visit} />
            <VisitTasksList tasks={visit.tasks} />
          </div>
          <div className="flex min-w-0 flex-col gap-4">
            <VisitInfoCard visit={visit} />
            {visit.location && <VisitLocationCard location={visit.location} />}
          </div>
        </div>
      ) : null}
    </PageContainer>
  );
}
